export function getStockResult(params: { safety?: number; current?: number }) {
  const { current = 0, safety = 0 } = params;
  if (typeof safety === 'undefined') return undefined;
  return current - safety > 0 ? 'release_exceeding' : 'not_release';
}
